<div class="modal-header">
  <h4 class="modal-title fw-normal">Edit File</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  @if (updating()) {
  <groundworks-state-message type="loading" message="Updating attachment..." class="d-flex" />
  } @else {
  <form [formGroup]="editForm" class="d-flex flex-column gap-3">
    <div>
      <label class="form-label" for="groupIdSelect">Attachment Group</label>
      <select class="form-select" formControlName="groupId">
        @for (group of attachmentGroups(); track group.id) {
        <option [value]="group.id">{{ group.name }}</option>
        }
      </select>
    </div>

    <div>
      <label class="form-label" for="descriptionInput">Description</label>
      <input type="text" class="form-control" placeholder="Please select" formControlName="description" />
    </div>
  </form>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-primary" type="button" (click)="onSave()" [disabled]="updating()">
    Save
  </button>
</div>
